export const formatPrice = (value) => {
  if (value == null || isNaN(value) || !value || value==="Infinity") return "0";

  let num = Number(value);

  // If more than 2 decimals → fix to 2
  if (num % 1 !== 0 && value.toString().split(".")[1].length > 2) {
    num = Number(num.toFixed(2));
  }

  const [intPart, decimalPart] = num.toString().split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
};
export const formatPricewithdesimal = (value) => {
    if (value == null || isNaN(value) || !value || value==="Infinity") return "0";

  let strValue = value.toString();

  // Check if it ends with a dot
  const hasTrailingDot = strValue.endsWith(".");

  let num = Number(value);

  // Round to 2 decimals if needed
  if (!hasTrailingDot && num % 1 !== 0 && strValue.split(".")[1]?.length > 2) {
    num = Number(num.toFixed(2));
    strValue = num.toString();
  }

  const [intPart, decimalPart] = strValue.split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (hasTrailingDot) return `${withCommas}.`;
  return decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
};

export const unformatPrice = (formattedValue) => {
  if (!formattedValue) return 0;
  const numericValue = formattedValue.toString().replace(/,/g, "");
  const num = parseFloat(numericValue);
  return isNaN(num) ? 0 : num;
};